var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15657 22.5407C0.592883 21.9845 0.592883 21.0828 1.15657 20.5266L21.2004 0.750496C21.7641 0.194333 22.678 0.194334 23.2417 0.750497C23.8054 1.30666 23.8054 2.20838 23.2417 2.76454L3.19788 22.5407C2.63419 23.0969 1.72026 23.0968 1.15657 22.5407Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.758217 1.4594C1.32191 0.903233 2.23583 0.903233 2.79952 1.4594L22.8433 21.2355C23.407 21.7917 23.407 22.6934 22.8433 23.2496C22.2796 23.8057 21.3657 23.8057 20.802 23.2496L0.758217 3.47344C0.194526 2.91728 0.194527 2.01556 0.758217 1.4594Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCross);
export default __webpack_public_path__ + "static/media/MenuCross.4f0e1418.svg";
export { ForwardRef as ReactComponent };